import { useQuery } from '@tanstack/react-query';
import { AxiosInstance } from '../../../utilities/requestClient';
import { ComplianceDataResponse } from './types/dashboard.types';

const buildRangeQueryKey = (
  startDate: string | null,
  endDate: string | null,
  raptorPlatformId: string | undefined,
) => ['dashboard-data-v2', startDate, endDate, raptorPlatformId] as const;

export { buildRangeQueryKey };

export const fetchCustomDateRangeData = async (
  startDate: string | null,
  endDate: string | null,
  raptorPlatformId?: string,
): Promise<ComplianceDataResponse> => {
  let baseUrl: string;

  if (startDate === null && endDate === null) {
    baseUrl = 'dashboard-data-v2';
  } else {
    baseUrl = `dashboard-data-v2/${startDate}/${endDate}`;
  }

  if (raptorPlatformId) {
    baseUrl +=
      (baseUrl.includes('?') ? '&' : '?') +
      `raptor_platform_id=${raptorPlatformId}`;
  }

  const response = await AxiosInstance.get<ComplianceDataResponse>(baseUrl);

  return response.data;
};

export function useCustomDateRangeQuery(
  startDate: string | null,
  endDate: string | null,
  raptorPlatformId?: string,
) {
  return useQuery({
    queryKey: buildRangeQueryKey(startDate, endDate, raptorPlatformId),
    queryFn: () =>
      fetchCustomDateRangeData(startDate, endDate, raptorPlatformId),
    enabled:
      (startDate === null && endDate === null) || (!!startDate && !!endDate),
    staleTime: 60 * 60 * 1000,
  });
}
